import serverVars from 'server-vars';
import { isBot, BOT_TYPE } from './botTypeHelpers';

export const getIsBotOnClient = (): boolean => isBot(serverVars.get(BOT_TYPE));
